export default class TicketTemplatePreviewController {
    constructor($scope, $injector) {
        this.scope = $scope;
        this.injector = $injector;

        this._initWatchers();
    }

    _initWatchers() {
        this.scope.$watch(() => {
           return this.previewData;
        }, (newData) => {
            if(this.previewData) {
                this.fillIframe();
            }
        }, true);
    }

    fillIframe() {
        const iFrame = angular.element('#ticket-template-preview-iframe'),
            iframeDoc = iFrame[0].contentWindow.document;

        iframeDoc.open();
        iframeDoc.write(this.getDefaultTicketPreview());
        iframeDoc.close();
    }

    getDefaultTicketPreview() {
        return `<!doctype html>
            <html lang="en">
            <head>
                <meta charset="utf-8">
                <title>Ticket Preview</title>
                <style>
                    body {
                        margin: 0 !important;
                        padding: 0 !important;
                    }
            
                    div {
                        background: blue;
                        display: inline;
                    }
            
                    #ticket-wrapper {
                        font-family: Arial, Helvetica, sans-serif;
                        background-color: #fff;
                        position: relative;
                        overflow: hidden;
                        width: ${this.previewData.pdf_options['page-width']};
                        height: ${this.previewData.pdf_options['page-height']};
                    }
            
                    #ticket-image {
                        position: absolute;
                        top: 0;
                        left: 0;
                        width: ${this.previewData.pdf_options['page-width']};
                        height: ${this.previewData.pdf_options['page-height']};
                    }
            
                    #qr-code {
                        position: absolute;
                        width: ${this.previewData.pdf_options.qr_code.size};
                        height: ${this.previewData.pdf_options.qr_code.size};
                        top: ${this.previewData.pdf_options.qr_code.top};
                        left: ${this.previewData.pdf_options.qr_code.left};
                        margin: 0 !important;
                        padding: 0 !important;
                    }
            
                    #ticket-text {
                        position: absolute;
                        font-size: ${this.previewData.pdf_options.text.size};
                        color: ${this.previewData.pdf_options.text.color};
                        top: ${this.previewData.pdf_options.text.top};
                        left: ${this.previewData.pdf_options.text.left};
                    }
                </style>
            </head>
            <body>
            <div id="ticket-wrapper">
                <img src="${(this.previewData.background_image) ? this.previewData.background_image.url : 'https://placehold.it/'+this.previewData.pdf_options['page-width']+'x'+this.previewData.pdf_options['page-height']+'/efefef/efefef'}" id="ticket-image" alt="background"/>
                <img id="qr-code" src="https://placehold.it/300x300?text=QR-Code" alt="QR-Code"/>
                <p id="ticket-text">${this.previewData.template}</p>
            </div>
            </body>
            </html>`;
    }
}

TicketTemplatePreviewController.$inject = [
    '$scope',
    '$injector'
];



// WEBPACK FOOTER //
// ./src/app/modules/tickets/templates/components/al-ticket-template-preview/controller.js